<script lang="ts">
    import type ServiceProvider from '../services/service.provider'
    import type { OfficialBoardRecord } from '../interfaces/interfaces'
    import { ymdToDmy } from '../../../core/utils/date.util'
    import Pager from './Pager.svelte'

    export let serviceProvider: ServiceProvider

    let resultList: OfficialBoardRecord[] = []
    let total = 0
    let error = false
    let processing = false

    const dateNow = new Date().toLocaleDateString('cs-CZ')

    serviceProvider.searchService.listSubs.subscribe((list) => {
        resultList = list
    })
    serviceProvider.searchService.totalSubs.subscribe((number) => (total = number))
    serviceProvider.searchService.errorSubs.subscribe((status) => (error = status))
    serviceProvider.searchService.processingSubs.subscribe((status) => (processing = status))

    const cols = [
        { key: 'oblast', name: 'Oblast' },
        { key: 'kategorie', name: 'Kategorie' },
        { key: 'nazev', name: 'Název' },
        { key: 'cisloJednaci', name: 'Číslo jednací' },
        { key: 'puvodce', name: 'Původce' },
        { key: 'zverejneniOd', name: 'Zveřejněno OD' },
        { key: 'zverejneniDo', name: 'DO' },
        { key: 'dokument', name: 'Dokument' },
    ]
</script>

{#if processing}
    <h2>Vyhledávám...</h2>
{:else if error}
    <h2>Výsledky vyhledávání</h2>
    <p>Nastala chyba při vyhledávání</p>
{:else}
    <h2>Úřední deska – stav k {dateNow}</h2>

    {#if Array.isArray(resultList) && resultList.length}
        <div class="bno-table__scrollable-container">
            <table class="bno-table bno-table--tablet-block bno-table--boxed">
                <thead>
                    {#each cols as col}
                        <th>
                            {col.name}
                        </th>
                    {/each}
                </thead>
                <tbody>
                    {#each resultList as item}
                        <tr>
                            {#each cols as col}
                                <td data-category="{col.name}">
                                    {#if col.key === 'nazev'}
                                        <a href={item.url} aria-label={item.title}>
                                            {item.title}
                                        </a>
                                    {:else if col.key === 'zverejneniOd'}
                                        {#if item.zverejneniOd}
                                            {ymdToDmy(item.zverejneniOd)}
                                        {:else}
                                            <strong style="color: #878787;">nezadáno</strong>
                                        {/if}
                                    {:else if col.key === 'zverejneniDo'}
                                        {#if item.zverejneniDo}
                                            {ymdToDmy(item.zverejneniDo)}
                                        {/if}
                                    {:else if col.key === 'dokument'}
                                        {#if Array.isArray(item.dokumentList) && item.dokumentList.length}
                                            <a
                                                href={item.dokumentList[0].url}
                                                target="{item.dokumentList[0].extension ? '_blank' : ''}"
                                                class="{item.dokumentList[0].extension ? 'bno-link--without-external-icon' : ''}"
                                                aria-label={item.dokumentList[0].name}
                                            >
                                                {item.dokumentList[0].name}
                                            </a>
                                            {#if item.dokumentList[0].size}
                                                <span>({item.dokumentList[0].size})</span>
                                            {/if}
                                            {#if item.dokumentList.length > 1}
                                                <br>
                                                <a class="bno-link" href={item.url} aria-label="Další dokumenty">
                                                    <span class="bno-icon bno-icon--folder"></span>
                                                    Další dokumenty
                                                </a>
                                            {/if}
                                        {/if}
                                    {:else}
                                        {item[col.key]}
                                    {/if}
                                </td>
                            {/each}
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
        {#if !processing && total > 10}
            <Pager {serviceProvider}/>
        {/if}
    {:else}
        <p>Vašemu zadání neodpovídají žádné výsledky</p>
    {/if}
{/if}
